// extracted by mini-css-extract-plugin
module.exports = {"illustration":"MiniCardV1_illustration__DSMeJ","title":"MiniCardV1_title__ytp3I","header":"MiniCardV1_header__7qNyF","mini":"MiniCardV1_mini__Qai1O"};